import type React from 'react';

import type * as CSS from 'csstype';
import capitalize from 'lodash/fp/capitalize';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import type { CommonProps, LayoutProps, PositionProps } from './constants';
import { COMMON, LAYOUT, POSITION } from './constants';
import theme from './theme';

type Props = CommonProps &
  LayoutProps &
  PositionProps & { as?: keyof JSX.IntrinsicElements | React.ComponentType<any> };

const Position = styled.div<Props>`
  ${COMMON}
  ${LAYOUT}
  ${POSITION}
`;

Position.defaultProps = {
  theme,
};

Position.propTypes = {
  ...COMMON.propTypes,
  ...LAYOUT.propTypes,
  ...POSITION.propTypes,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

function withPosition(position: CSS.PositionProperty) {
  const WithPosition = styled(Position)`
    position: ${position};
  `;
  WithPosition.propTypes = Position.propTypes;
  WithPosition.defaultProps = Position.defaultProps;
  WithPosition.displayName = `Position${capitalize(position)}`;
  return WithPosition;
}

Position.displayName = 'Position';

export { Position };
export const Absolute = withPosition('absolute');
export const Fixed = withPosition('fixed');
export const Relative = withPosition('relative');
export const Sticky = withPosition('sticky');
